import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex h-screen bg-gray-200 font-roboto" }
const _hoisted_2 = { class: "flex-1 flex flex-col overflow-hidden" }
const _hoisted_3 = { class: "flex-1 overflow-x-auto overflow-y-auto bg-gray-200 md:min-w-[1000px]" }
const _hoisted_4 = {
  key: 0,
  class: "text-rose-600 text-3xl p-4 font-semibold text-center"
}
const _hoisted_5 = { class: "mx-auto px-6 py-8 w-100" }

import Sidebar from '../Sidebar.vue'
import Header from "@/components/Header.vue";
import CommonModal from "@/components/modals/CommonModal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardLayout',
  setup(__props) {

const isNotProduction = process.env.VUE_APP_ENV !== 'production'

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$route.name !== 'NotFound')
      ? (_openBlock(), _createBlock(Sidebar, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Header, { class: "lg:hidden" }),
      _createElementVNode("main", _hoisted_3, [
        isNotProduction
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, " 본 페이지는 개발페이지입니다. 계정 생성 및 작업 시 실제 적용이 되지 않습니다. "))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _createVNode(CommonModal)
      ])
    ])
  ]))
}
}

})